// https://www.color-hex.com/color-palette/57915
const VaporwavePink = "#FF00C1"; //rgb(255, 0, 193)
const VaporwavePurple = "#9600FF"; //rgb(150, 0, 255)
const VaporwaveBlue = "#4900FF"; //rgb(73, 0, 255)
const VaporwaveBlueGreen = "#00b8ff"; //rgb(0, 184, 255)
const VaporwaveGreen = "#00fff9"; //rgb(0, 255, 249)

export {
  VaporwavePink,
  VaporwavePurple,
  VaporwaveBlue,
  VaporwaveBlueGreen,
  VaporwaveGreen,
};
